import { render, staticRenderFns } from "./DanceGUI.vue?vue&type=template&id=57d5e4c2&"
import script from "./DanceGUI.vue?vue&type=script&lang=js&"
export * from "./DanceGUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports